/**
 * Build flavor — controla QUAL versao do site sai da compilacao.
 *
 *   npm run build       -> flavor "liberty" (site publico completo: home, cadastro,
 *                          dashboard do player, painel GM, auth Google/SMS, marca Liberty)
 *   npm run build:dev   -> flavor "dev"     (staff/outro host: SO login basico + painel
 *                          GM; sem home, sem cadastro, sem Google/SMS, marca generica
 *                          "Cabal", tema preto+dourado)
 *
 * Como `import.meta.env.VITE_APP_FLAVOR` vira LITERAL no build, os `if (IS_DEV_BUILD)`
 * viram constante e o Rollup remove o codigo do outro lado (tree-shaking) — o build dev
 * nem carrega o SDK do Google, home, dashboard etc.
 */
export type AppFlavor = 'liberty' | 'dev';

export const APP_FLAVOR: AppFlavor =
  (import.meta.env.VITE_APP_FLAVOR as AppFlavor) || 'liberty';

export const IS_DEV_BUILD = APP_FLAVOR === 'dev';

/** Nome da marca exibido no site. Configuravel por build (VITE_BRAND_NAME). */
export const BRAND_NAME: string =
  import.meta.env.VITE_BRAND_NAME || (IS_DEV_BUILD ? 'Cabal' : 'Cabal Liberty EP39');

/** Feature flags derivadas do flavor. */
export const SHOW_HOME = !IS_DEV_BUILD;         // home publica / marketing
export const SHOW_REGISTER = !IS_DEV_BUILD;     // cadastro (dev cria conta via banco/painel)
export const SHOW_DASHBOARD = !IS_DEV_BUILD;    // painel do player
export const SHOW_PUBLIC_NEWS = !IS_DEV_BUILD;  // /news publico
export const SHOW_GOOGLE_AUTH = !IS_DEV_BUILD;  // login com Google
export const SHOW_SMS_AUTH = !IS_DEV_BUILD;     // OTP/SMS
export const SHOW_SOCIAL = !IS_DEV_BUILD;       // links sociais (facebook/share)
